module.exports = __webpack_public_path__ + "img/pita_pit.a16b570e.jpg";